import core from './core';
import { DeviceManager } from './DeviceManager';
import Tracker from '../helpers/tracker';
import { Xhr } from '../Modules/HttpRequest';
import { ApiEndpoints } from '../Configurations/ApiEndpoints';
import { TrackingData } from '../helpers/TrackingTypes';

const TeaserTiles = core.extend({
	constructor(config) {
		this.config = { el: '.google-wrapper' };

		_.extend(this.config, config);

		this.element = document.querySelector(this.config.el);
		this.mobileProductsHolder = document.querySelector('.js-google-shopping-category-grid');
		this.deviceManager = new DeviceManager();

		this.desktopAmount = window.frontendTheme === 'rosemood' ? 8 : 6;

		this.init();
	},

	init() {
		this.getTeaserTiles();
		this.getTeaserTilesMobile();

		this.deviceManager.addEventListener('device:width:changed', () => {
			this.displayProducts();
		});
	},

	displayProducts() {
		const isMobileDevice = this.deviceManager.isMobileDevice();
		const categoryLinkWrapper = this.element.parentElement.querySelector('.js-category-link-wrap');

		categoryLinkWrapper.classList.remove('is-hidden');

		if (isMobileDevice) {
			this.mobileProductsHolder.classList.remove('is-hidden');
		} else {
			this.element.classList.remove('is-hidden');
		}
	},

	getTeaserTiles() {
		Xhr.getJson(ApiEndpoints.TEASER_PRODUCTS, { size: this.desktopAmount, ...this.config.data })
			.then((response) => this.onTeaserTiles(response))
			.catch((xhrResponse) => Xhr.logXhrPromiseRejection(xhrResponse, 'TeaserTiles on getTeaserTiles'));
	},

	getTeaserTilesMobile() {
		Xhr.getJson(ApiEndpoints.TEASER_PRODUCTS, { size: 21, ...this.config.data })
			.then((response) => this.onTeaserTiles(response, true))
			.catch((xhrResponse) => Xhr.logXhrPromiseRejection(xhrResponse, 'TeaserTiles on getTeaserTiles'));
	},

	addMobileGridButton(images) {
		if (images.length > 20) {
			const lastChild = this.mobileProductsHolder.querySelector('li:last-child');
			const categoryUrl = lastChild.querySelector('.link-cp').href;

			this.addMobileGridButtonBySelector(lastChild);

			if (this.config.data.teaserVariant === '1') {
				this.showMobileGridButtonBySelector(
					document.querySelector('.shopping-category-grid-button-top'),
					categoryUrl
				);
			}

			if (this.config.data.teaserVariant === '99') {
				this.showMobileGridButtonBySelector(
					document.querySelector('.shopping-category-grid-button-middle'),
					categoryUrl
				);
			}
		}
	},
	showMobileGridButtonBySelector(hiddenMoreProductsButton, categoryUrl) {
		hiddenMoreProductsButton.classList.remove('is-hidden');

		const cpLink = hiddenMoreProductsButton.querySelector('.js-link-cp');
		cpLink.href = categoryUrl;
		this.addMobileGridButtonBySelector(hiddenMoreProductsButton);

		cpLink.addEventListener('click', (event) => {
			const url = event.currentTarget.href;

			event.preventDefault();
			this.trackLinks(TrackingData.ACTION_SHOPPING_CP_CLICK, url, url);
		});
	},
	addMobileGridButtonBySelector(affectedChild) {
		const goToCategoryButton = affectedChild.querySelector('.go-to-cp');
		affectedChild.classList.add('shopping-category-grid-button');
	},
	onTeaserTiles(response, mobile = false) {
		this.displayProducts();

		const tileSelector = mobile ? '.js-teaser-tiles-mobile' : '.js-teaser-tiles';

		if (response.data) {
			const listElement = document.querySelector(tileSelector);
			listElement.innerHTML = response.data;

			const listItemsAmount = listElement.children.length;
			listElement.classList.add('tiles-amount-' + listItemsAmount);
		}

		if (mobile) {
			const images = this.mobileProductsHolder.querySelectorAll('.product-img');

			this.addMobileGridButton(images);
		}

		const cpLinks = this.element.querySelectorAll('.js-link-cp');
		const pdpLinks = this.element.querySelectorAll('.js-link-pdp');

		_.each(pdpLinks, (pdpLink) => {
			pdpLink.addEventListener('click', (event) => {
				const url = event.currentTarget.href;

				event.preventDefault();
				this.trackLinks(TrackingData.ACTION_SHOPPING_PDP_CLICK, url, url);
			});
		});

		_.each(cpLinks, (cpLink) => {
			cpLink.addEventListener('click', (event) => {
				const url = event.currentTarget.href;

				event.preventDefault();
				this.trackLinks(TrackingData.ACTION_SHOPPING_CP_CLICK, url, url);
			});
		});
	},

	trackLinks(action, label, url) {
		Tracker.trackAndNavigate(
			{
				category: this.config.trackingCategory,
				action,
				label,
			},
			url
		);
	},
});

export default TeaserTiles;
